import { useEffect } from 'react';
import { getHostedPageFlowType } from 'utilities/global';
import { Tracker } from 'services/tracking';

let tracker = null;

const setTracker = trackerName => {
  tracker = new Tracker(trackerName);
};

export function useAnalytics(customTracker) {
  if (!tracker) {
    setTracker(customTracker || getHostedPageFlowType());
  }

  useEffect(() => {
    if (customTracker) {
      setTracker(customTracker);
    }
  }, [customTracker]);

  return tracker;
}
